import { render, staticRenderFns } from "./SelfDiagnosisChart.vue?vue&type=template&id=6afec734&scoped=true&"
import script from "./SelfDiagnosisChart.vue?vue&type=script&lang=js&"
export * from "./SelfDiagnosisChart.vue?vue&type=script&lang=js&"
import style0 from "./SelfDiagnosisChart.vue?vue&type=style&index=0&id=6afec734&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afec734",
  null
  
)

export default component.exports